import * as $ from 'jquery';

export class recaptchaObject {
	private recaptchaUrl:string = "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit";

	createInput(elId:string, elCb:string, elDisplayId:string):string {
		let el:any = $('<input type="text">');

		el.attr({
			'id': elId,
			'class': 'hidden',
			'name': 'complete-recaptcha',
			'data-recaptcha-field': 1,
			'data-recaptcha-cb': elCb,
			'data-recaptcha-display': elDisplayId,
			'data-parsley-required': 'true',
			'required': 'required',
			'readonly': 'readonly'
		});
		let elStr:string = el.prop('outerHTML');

		return elStr;
	}

	extendInput(elId:string, elCb:string, elDisplayId:string): void {
		let el:any = $('#'+elId);

		el.attr({
			'data-recaptcha-field': 1,
			'data-recaptcha-cb': elCb,
			'data-recaptcha-display': elDisplayId
		});
	}

	createRecaptchaField(obj:recaptchaInfo): void {
		let _self = this;
		let _body = $('body');

		// create hidden input if does not exist
		// - caters for c035 & c048
		if (!$('#'+obj.id).length) {
			let recaptchaInput = _self.createInput(obj.id, obj.cb, obj.displayId);

			obj.formEl.append(recaptchaInput);
		} else {
			_self.extendInput(obj.id, obj.cb, obj.displayId);
		}

		_body.append('<script>var '+obj.cb+' = '+obj.cbObj+'</script>');

		$('document').trigger('recaptcha.init', [obj.id, obj.cb]);
		$('#'+obj.id).attr({'data-recaptcha-triggered': 1}); // mark as triggered once done
	}

	initRecaptchaScript(): void {
		let _self = this;
		let _body = $('body');
		console.log('%cinit recaptcha', 'background-color: green; color: white');


		let recaptchaFn = function(): void {

			// get sitekey from hidden input on page
			let siteKey:string = $('#recaptcha-sitekey').val();

			// for all recaptcha init events that occur before callback fn is triggered
			$('[data-recaptcha-field]').each((i:number, el:any) => {
				let $el = $(el);
				if ($el.attr('data-recaptcha-triggered') && !$el.attr('data-recaptcha-ready')) {
					const cbMethodName:string = $el.attr('data-recaptcha-cb');
					const cbDisplayEl:HTMLElement = document.getElementById($el.attr('data-recaptcha-display'));

					grecaptcha.render(cbDisplayEl, {
						'sitekey' : siteKey,
						'callback' : cbMethodName,
					});

					$el.attr({
						'data-recaptcha-ready': 1
					})
				}
			});

			// for all subsequent recaptcha init events that occur after callback fn is triggered
			$('document').on('recaptcha.init', function(e:any, fieldId:string, cbMethodName:string) {
				console.log('render recaptcha for #'+ fieldId + ' with callback method ' + cbMethodName + '()');
				const cbDisplayEl:HTMLElement = document.getElementById($('#'+fieldId).attr('data-recaptcha-display'));
		    grecaptcha.render(cbDisplayEl, {
		      'sitekey' : siteKey,
          'callback' : cbMethodName,
		    });
			});
		}

		_body.append('<script id="recaptcha-fn">var onloadCallback = '+recaptchaFn.toString()+'</script>');
		_body.append('<script id="recaptcha-src" src="'+_self.recaptchaUrl+'"></script>');
	}
}

try {
	let recaptchaobj = new recaptchaObject();
	recaptchaobj.initRecaptchaScript();
} catch(e) {console.error(e);}

